import { IconButton } from "@mui/material";
import React, { useCallback } from "react";
import { FormControl } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close"
import { debounce } from "../../../_metronic/_helpers/debounce";
import { useLocation } from "react-router";


export default function GlobalFormControl(props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const reset = useCallback(
    debounce((event) => {
      if (event.key == "Escape") {
        props.onChange({ target: { value: "" } })
        if (searchParams.get("globalSearch")) {
          document.getElementById("submitButton").click();
        }
      }
    }, 300)
    , [props])
  return (
    <div className="d-flex flex-grow-1 position-relative">
      <FormControl
        onKeyDown={reset}
        type="search"
        {...props}
      />
      {props.value &&
        <IconButton
          sx={{
            position: "absolute",
            left: "0",
            top: 5
          }}
          size="small"
          onClick={(e) => {
            props.onChange({ target: { value: "" } })
            document.getElementById("submitButton").click();
          }}>
          <CloseIcon fontSize="small" />
        </IconButton>}
    </div>
  );
}
